import { useSuspenseQuery } from '@apollo/client';

import type { UnauthorizedJobReason } from '@xing-com/crate-common-graphql-types';
import type { JobDetailsVisibleJobFragment } from '@xing-com/crate-jobs-graphql';
import { GetJobDetailsDocument } from '@xing-com/crate-jobs-graphql';

import { useVisibleJobTypePolicies } from './use-visible-job-type-policies';

type JobDetailsResponse = {
  job?: JobDetailsVisibleJobFragment;
  jobId?: string;
  error?: UnauthorizedJobReason;
};

export const useJobDetails = (slug: string): JobDetailsResponse => {
  useVisibleJobTypePolicies();
  const { data } = useSuspenseQuery(GetJobDetailsDocument, {
    variables: { slug },
    errorPolicy: 'all',
  });

  if (data?.job?.__typename === 'UnauthorizedJob')
    return { error: data.job.reason, jobId: data.job.id };

  const job = data?.job?.__typename === 'VisibleJob' ? data.job : undefined;

  return { job };
};
